import {
  useEffect,
  useMemo,
  useState
} from 'react';



export interface IData { }

export type IBasePopperProps = {
  handleClose: () => void;
  open: boolean;
  anchorEl: null | HTMLElement;
  id: string;
};

export function useBasePopperState() {
  const [
    anchorEl,
    setAnchorEl
  ] = useState<null | HTMLElement>(null);

  useEffect(() => {
    setAnchorEl((prev) => prev !== anchorEl ? anchorEl : prev);
    return () => { };
  }, [anchorEl]);

  return useMemo(
    () => {
      const handleClose = () => {
        setAnchorEl(() => null);
      };

      const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        setAnchorEl((prev) => prev !== e.currentTarget ? e.currentTarget : prev);
      };

      return {
        handleClose,
        handleClick,
        open: anchorEl != null,
        anchorEl
      };
    },
    [anchorEl]
  );
}


